import esquemaEmpleado from '../schemas/empleadoSchema';
import {
  numeroNormalizado,
  limpiarString,
} from '../../../../utils/normalizarDatosUtil';

/**
 * Crea un Map de Sigla -> ID (En este caso coinciden, pero mantiene la abstracción)
 * @param {Array} listaDocumentos
 */
export const construirMapaDocumentos = listaDocumentos =>
  new Map(listaDocumentos.map(documento => [documento._id, documento._id]));

/**
 * Construye un Map de descripción → _id desde la lista de tiposContratos de la DB.
 * Permite que el normalizador no dependa de IDs hardcodeados.
 * @param {Array<{ _id: number, DescTipoContrato: string }>} tiposContratos
 * @returns {Map<string, number>}
 */
export const construirMapaContratos = tiposContratos =>
  new Map(
    tiposContratos.map(contrato => [contrato.DescTipoContrato, contrato._id])
  );

const MAPA_EMBARGO = { Sí: true, No: false };
const MAPA_INSOLVENTE = { Sí: true, No: false };

/**
 * Normaliza los datos crudos del Excel a un objeto plano de primer nivel.
 * @param {Array} data - Datos crudos de la hoja de Excel.
 */
export const normalizarDatosJson = (data, mapaDocumentos, mapaContratos) => {
  return data.map((fila, index) => {
    return {
      nombres: limpiarString(fila.Nombres),
      primerApellido: limpiarString(fila['Primer apellido']),
      segundoApellido: limpiarString(fila['Segundo apellido']) || null,
      TipoDocumento:
        mapaDocumentos.get(fila['Tipo de documento']) ??
        fila['Tipo de documento'] ??
        null,
      NumeroDocumento: numeroNormalizado(fila['Número de documento']),
      Cargo: limpiarString(fila.Cargo),
      FechaIngreso: fila['Fecha de ingreso'] ?? null,
      FechaContratoHasta: fila['Fecha contrato hasta'] ?? null,
      Telefono: numeroNormalizado(fila['Teléfono']),
      Salario: numeroNormalizado(fila['Salario']),
      TipoContrato:
        mapaContratos.get(fila['Tipo de contrato']) ??
        fila['Tipo de contrato'] ??
        null,
      TipoContratoTexto: fila['Tipo de contrato'] ?? null,
      Embargo: MAPA_EMBARGO[fila.Embargo] ?? fila.Embargo ?? null,
      esInsolvente:
        MAPA_INSOLVENTE[fila['¿Insolvente legalmente?']] ??
        fila['¿Insolvente legalmente?'] ??
        null,
      otrasDeduccionesSalario: numeroNormalizado(
        fila['Otras deducciones Salario']
      ),
      cantidadLlamadosAtencion: numeroNormalizado(
        fila['Cantidad llamados atención']
      ),
      evaluacionDesempeno: numeroNormalizado(fila['Evaluación desempeño']),
      montoMaximoCuota: numeroNormalizado(fila['Monto máximo cuota']),
      diasVacacionesDisponibles: numeroNormalizado(
        fila['Días vacaciones disponibles']
      ),
      tipoSalario: null,
      frecuenciaPago: fila['Frecuencia de pago'] ?? null,
      tipoCuentaBancaria: fila['Tipo de cuenta bancaria'] ?? null,
      entidadBancaria: fila['Entidad bancaria'] ?? null,
      numeroCuentaBancaria: limpiarString(fila['Número de cuenta bancaria']),
      lineaExcel: index + 2,
    };
  });
};

/**
 * Transforma un objeto plano a la estructura requerida por el backend.
 * @param {Object} empleadoPlano
 * @returns {Object} Empleado estructurado
 */
export const estructurarBackend = empleadoPlano => {
  return esquemaEmpleado.reduce((acumulador, campo) => {
    const valor = empleadoPlano[campo.name];

    if (!campo.folder) {
      return {
        ...acumulador,
        [campo.name]: valor,
      };
    }

    const subNivelExistente = acumulador[campo.folder] || {};

    return {
      ...acumulador,
      [campo.folder]: {
        ...subNivelExistente,
        [campo.name]: valor,
      },
    };
  }, {});
};
